module.exports = __webpack_public_path__ + "img/rmps.e7cc702c.png";